export function getCovidModelFingerprint(): string[] {
  return ['WSiaCG9qSHOBF0MK7lUa1g'];
}

export function getIndicatorModelFingerprint(): string[] {
  return ['K4HsnmnUR1y5xb7q4ClfYQ', 'PO2uzkbDQUK4WpNQBvHowg'];
}
